import styled from 'styled-components';
import Form from 'components/form';
import { H3 } from 'components/typography';
import { ReactComponent as Check } from 'styles/icons/check.svg';
import { normalize } from 'utils/styles';
import { color, typography } from 'styles/settings';

export const Overlay = styled.div`
  background-color: ${color.brand.greenDarkWithOpacity(0.3)};
  width: 100vw;
  height: 100vh;
  overflow: none;
  position: relative;
`;

export const Container = styled.div`
  background-color: ${color.neutral.white};
  margin: 0;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${normalize('24px')} ${normalize('32px')};
  max-width: 420px;
`;

export const StyledButton = styled(Form.Button)`
  * {
    color: ${color.brand.greenDark};
  }
`;

export const FormTextInput = styled(Form.TextInput)`
  width: ${normalize('375px')};
  height: 60px;
  font-size: ${typography.size.md};
`;

export const Text = styled(H3)`
  ${typography.font.medium};
`;

export const ModalContent = styled.div`
  margin: ${normalize('24px')} ${normalize('64px')};
  margin-bottom: ${normalize('36px')};
  margin-left: 0;
`;

export const CheckIcon = styled(Check)`
  color: ${color.brand.green};
  height: ${normalize('24px')};
  width: ${normalize('24px')};
  padding-right: ${normalize('6px')};
`;
